<script>
import Detail from './detail'
import DatePicker from "@vuepic/vue-datepicker"
//import PartnerTreeMenu from '@/components/partner/tree-menu'
import PartnerBadge from '../badge-level'
import BadgeSeamless from "@/components/badge-seamless"
import BadgeTransactionType from "@/components/badge-transaction-type"
import BadgeTransactionCategory from "@/components/badge-transaction-category"
import BadgeGameCategory from "@/components/badge-game-category"
import BadgeGameTarget from "@/components/badge-game-target"
import EvolutionParser from "@/libraries/vendor/evolution-v3"
import BGParser from "@/libraries/vendor/bg-v3"
import DGParser from "@/libraries/vendor/dg-v3"
import AGParser from "@/libraries/vendor/ag-v3"
import BotaParser from "@/libraries/vendor/bota-v3"
import VivoParser from "@/libraries/vendor/vivo-v3"
import WmParser from "@/libraries/vendor/wm-v3"
import SelectVendors from "@/components/select-vendors"
import SelectGames from "@/components/select-games"
import { md5 } from '@/helpers/string'

export default {
  props: {
    user:Object,
    searchByUser:Boolean
  },
  components: {
    Detail,
    DatePicker,
    //PartnerTreeMenu,
    PartnerBadge,
    BadgeSeamless,
    BadgeTransactionType,
    BadgeTransactionCategory,
    BadgeGameCategory,
    BadgeGameTarget,
    SelectVendors,
    SelectGames
  },
  data() {
    return {
      intervalId: null,
      search: {
        groupKey: '',
        searchType: 'username',
        searchText: '',
        method: 'game',
        category: 'turn',
        type: 'bet',
        vendor: '',
        game: '',
        seamlessState: '',
        beginDate: '',
        endDate: '',
        parent: null
      },
      filter: {
        resultType: ''
      },
      sort: { createdAt: -1 },
      list: [],
      filterList: [],
      limit: 200,
      totalCount: 0, // 총갯수
      totalPageCount: 0, // 총 페이지수
      page: 1, // 현재 페이지

      vendors: [],
      games: [],
      evolutionParser: new EvolutionParser(),
      bgParser: new BGParser(),
      dgParser: new DGParser(),
      agParser: new AGParser(),
      botaParser: new BotaParser(),
      vivoParser: new VivoParser(),
      wmParser: new WmParser()
    }
  },
  created() {

  },
  mounted() {
    let now = new Date();

    this.search.beginDate = new Date(now.getTime() - 60 * 60 * 1000);
    this.search.endDate = now

    this.search.parent = this.parent ? this.parent.id : null

    if(this.searchByUser == true) {
      if(this.user.username) this.search.searchText = this.user.username
      // this.searchList().then()
    }

    this.searchList();

    // 15초마다 실행
    this.intervalId = setInterval(() => {
      this.searchList();
    }, 10000);
    //else this.$refs.partnerTreeMenu.getPartners().then()
  },
  beforeUnmount() {
    // 메모리 누수 방지
    clearInterval(this.intervalId);
  },
  methods: {
    setParent: function(id) {
      this.search.parent = id
    },
    setSort: function(field) {
      let dir
      if (this.sort[field]) {
        dir = this.sort[field] * -1
      } else {
        dir = -1
      }

      this.sort = {}
      this.sort[field] = dir
      this.searchList().then()
    },
    goFirst() {
      this.page = 1
    },
    goPre() {
      if (this.page === 1) {
        this.page = 1
      } else {
        this.page -= 1
      }
    },
    goNext() {
      this.page += 1
    },
    searchByPage: function(page) {
      this.page = page
    },
    searchList: async function() {

      const now = new Date();
      this.search.beginDate = new Date(now.getTime() - 60 * 60 * 1000); // 1시간 전
      this.search.endDate = now;

      const loader = this.$loading.show()
      try {
        localStorage.setItem('limit', this.limit)
        const params = {
          search: { method: this.search.method, category: this.search.category, type: this.search.type, vendor: this.search.vendor, game: this.search.game, seamlessState: this.search.seamlessState, parent: this.search.parent },
          // search: { method: this.search.method, category: this.search.category, type: this.search.type, vendor: 96, game: this.search.game, seamlessState: this.search.seamlessState, parent: this.search.parent },
          sdate: this.search.beginDate,
          edate: this.search.endDate,
          sort: this.sort,
          limit: this.limit,
          page: this.page
        }
        params.search[this.search.searchType] = this.search.searchText

        if(this.filter && this.filter.resultType) {
          params.filter = {
            resultType: this.filter.resultType
          }
        }

        const result = await this.$API.transaction.games(params)

        if (result.code !== 0) {
          return alert(result.msg)
        }

        this.list = []
        for(let key in result.documents) {
          let doc = result.documents[key]
          if (doc.detail) {
            if (doc.vendorKey === 'evolution_casino') {
              doc.info = this.evolutionParser.set(doc.detail)
            }
            else if(doc.vendorKey === 'bg_casino') {
              doc.info = this.bgParser.set(doc.detail)
            }
            else if(doc.vendorKey === 'wm_casino'){
              doc.info = this.wmParser.set(doc)
            }
            doc.showDetail = false
          }
          if(doc.vendorKey === 'ag_casino' && doc.children.length > 0){
            doc.info = this.agParser.set(doc)
          }
          else if(doc.vendorKey === 'bota_casino' && doc.children.length > 0){
            doc.info = this.botaParser.set(doc)
          }
          else if(doc.vendorKey === 'vivo_casino' && doc.children.length > 0){
            doc.info = this.vivoParser.set(doc)
          }

          this.list.push(doc)
        }


        const transactionCodesWithChildren = this.list.filter(record => record.children.length > 0)
                                                      .map(record => record.siteRoundId);

         this.filterList = this.list.filter(record => {
          return !transactionCodesWithChildren.includes(record.siteRoundId);
        });

        const codesToCheck = this.filterList
          .map(record => record.data?.transaction_code)
          .filter(code => typeof code === 'string');

        if (codesToCheck.length === 0) {
          this.totalCount = 0;
          this.totalPageCount = 0;
          return;
        }

        const body = { checks: codesToCheck };

        const response = await this.$API.transaction.checkResult(body)

        if (response.code !== 0) {
          return alert('checkResult 오류가 발생했습니다.')
        }


        const nonResultTransactionKeys = response.nonResultTransactionKeys || [];
        if (nonResultTransactionKeys.length > 0) {
          this.filterList = this.filterList.filter(record =>
            nonResultTransactionKeys.includes(record.data.transaction_code)
          );
        }

        this.totalCount = result.totalCount
        this.totalPageCount = result.totalPageCount
      } catch(e) {
        this.$log.error(e)
      } finally {
        loader.hide()
      }
    },

    searchVendors(id) {
      this.search.vendor = id
      this.$refs.refSearchGames.getGames(id)
    },

    selectGames(id) {
      this.search.game = id
    },

    // 전송 데이터
    openData: function(data) {
      this.$refs['modal-detail'].open(data)
    },

    // 에볼, 프라그마틱, 드림게이밍 등 상세정보
    async openDetail(record) {
      let vType
      let vKeyType = record.vendorKey.split('_');
      if(vKeyType[1] === 'casino'){
        vType = 'casino'
      } else {
        vType = 'slot'
      }


      if (record.vendorKey === 'dg_casino') {
        const hash = md5(record.data.transaction_code+"878184ed37ef29322b414dcf7cb7e847")
        const url = `https://neo-game.app/bet-detail/${record.data.transaction_code}/${hash}`
        window.open(url, '', 'top=100, left=500, width=1500, height=1000 status=no, menubar=no, toolbar=no, resizable=no')
        return;
      }

      if (record.vendorKey === 'pragmatic_slot') {
        const result = await this.$API.transaction.getPragmaticLink(record.transactionKey)
        if (result.code !== 0) {
          return alert(result.msg)
        }
        window.open(result.url)
      }
      else if (
        vType === 'slot'
        /*
        record.vendorKey === 'fghub' || record.vendorKey === 'cq9_slot' || record.vendorKey === 'mtv_casino' ||
        record.vendorKey === 'dcs' || record.vendorKey === 'booongo_slot' || record.vendorKey === 'habanero_slot'||
        record.vendorKey === 'netgaming_slot' || record.vendorKey === 'gameart' || record.vendorKey === 'ftg_slot'||
        record.vendorKey === 'naga_slot' || record.vendorKey === 'aspect_slot' || record.vendorKey === 'ps'||
        record.vendorKey === 'pgsoft_slot' || record.vendorKey === 'skywind_slot' || record.vendorKey === 'netent_slot' ||
        record.vendorKey === 'redtiger_slot' || record.vendorKey === 'btg_slot'

         */
      ) {

        // 게임사와 매칭되는 벤더키를 보내준다.
        let vKey
        if(record.vendorKey === 'blueprint_slot' || record.vendorKey === 'dragoon_slot' || record.vendorKey === 'elysium_slot' || record.vendorKey === 'quickspin_slot' || record.vendorKey === 'redrake_slot' || record.vendorKey === 'spearhead_slot'){
          vKey = 'fghub'
        } else if(record.vendorKey === 'cq9_slot'){
          vKey = 'cq9'
        } else if(record.vendorKey === 'mtv_casino'){
          vKey = 'mtv'
        } else if(record.vendorKey === 'png_slot' || record.vendorKey === 'nlc_slot' || record.vendorKey === 'evo_slot' || record.vendorKey === 'hs_slot' || record.vendorKey === 'aux_slot' || record.vendorKey === 'relax_slot' || record.vendorKey === 'reelplay_slot' || record.vendorKey === 'fantasma_slot' || record.vendorKey === 'boomerang_slot' || record.vendorKey === '4tp_slot') {
          vKey = 'dcs'
        } else if(record.vendorKey === 'booongo_slot' || record.vendorKey === 'playson_slot'){
          vKey = 'booongo'
        } else if(record.vendorKey === 'habanero_slot' || record.vendorKey === 'gmw_slot'){
          vKey = 'habanero'
        } else if(record.vendorKey === 'netgaming_slot'){
          vKey = 'netgaming'
        } else if(record.vendorKey === 'gameart_slot'){
          vKey = 'gameart'
        } else if(record.vendorKey === 'ftg_slot'){
          vKey = 'ftg'
        } else if(record.vendorKey === 'naga_slot') {
          vKey = 'naga'
        } else if(record.vendorKey === 'aspect_slot'){
          vKey = 'aspect'
        } else if(record.vendorKey === 'ps_slot'){
          vKey = 'ps'
        } else if(record.vendorKey === 'pgsoft_slot'){
          vKey = 'pgsoft'
        } else if(record.vendorKey === 'skywind_slot'){
          vKey = 'skywind'
        } else if(record.vendorKey === 'netent_slot' || record.vendorKey === 'redtiger_slot' || record.vendorKey === 'btg_slot'){
          vKey = 'evolution'
        }

        const result = await this.$API.transaction.getSlotDetailLink(vKey, record.data.params.transactionKey)
        if (result.code !== 0) {
          return alert(result.msg)
        }
        window.open(result.url)
      }
      else if (record.vendorKey === 'oriental_casino') {
        window.open(record.children[0].data.result_url)
      }
      else if(record.vendorKey === 'bg_casino') {
        this.$refs['modal-detail'].open(record, 'detailResultBG')
      }
      else if(record.vendorKey === 'wm_casino') {
        this.$refs['modal-detail'].open(record, 'detailResultWM')
      }
      else if(record.vendorKey === 'vivo_casino') {
        this.$refs['modal-detail'].open(record, 'detailResultVIVO')
      }
      else if(record.vendorKey === 'ag_casino') {
        this.$refs['modal-detail'].open(record, 'detailResultAG')
      }
      else if(record.vendorKey === 'bota_casino') {
        // console.log("record->", record)
        this.$refs['modal-detail'].open(record, 'detailResultBota')
      }
      else if(record.vendorKey === 'evolution_casino') {
        this.$refs['modal-detail'].open(record, 'detailResultEvolution')
      }
      else if(record.vendorKey === 'dg_casino') {
        this.$refs['modal-detail'].open(record, 'detailResultDG')
      }
      else {
        // 에볼등 게임 상세내역 화면
        this.$refs['modal-detail'].open(record, 'detailResult')
      }
    },
    async openSeamlessLog(record) {
      this.$refs['modal-detail'].open(record, 'detailSeamless')
    }
  },
}
</script>

<style scoped>

</style>
<template>
  <div>
    <form class="header-search" @submit.prevent="searchList">

      <!-- 검색 //-->
      <div class="row">
        <div class="col-md-2" v-if="searchByUser != true"></div>
        <div class="form-group col-md-2 mb-2">
          <select-vendors @searchVendors="searchVendors"></select-vendors>
        </div>

        <div class="form-group col-md-2 mb-2">
          <select-games @selectGames="selectGames" ref="refSearchGames"></select-games>
        </div>

        <div class="form-group col-md-1 mb-2">
          <select class="form-select" v-model="search.seamlessState">
            <option value="">전체거래</option>
            <option value="ready">트랜스퍼거래</option>
            <option value="finish">심리스거래(완료)</option>
            <option value="error">심리스거래(오류)</option>
          </select>
        </div>

        <div class="form-group col-md-2 mb-2">
          <select class="form-select" v-model="filter.resultType">
            <option value="">게임결과</option>
            <option value="win">승</option>
            <option value="draw">무</option>
            <option value="lose">패</option>
            <option value="cancel">취소</option>
          </select>
        </div>

        <div class="form-group col-md-1 mb-2">
          <select class="form-select" v-model="search.searchType">
            <option value="username">아이디</option>
            <option value="siteUsername">사이트 아이디</option>
            <option value="parentTransactionKey">거래코드</option>
          </select>
        </div>

        <div class="form-group col-md-2 mb-2">
          <input type="text" class="form-control" v-model="search.searchText" :placeholder="$t('검색어')" />
        </div>
      </div>

      <!-- 페이징 및 검색 //-->
      <div class="row">
        <div class="col-md-3">
          <div class="form-group mb-2">
            <DatePicker
              v-model="search.beginDate"
              :format="'yyyy-MM-dd HH:mm:ss'"
              utc
              auto-apply
              :close-on-auto-apply="false"
              :placeholder="'시작일'"
            ></DatePicker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group mb-2">
            <DatePicker
              v-model="search.endDate"
              :format="'yyyy-MM-dd HH:mm:ss'"
              utc
              auto-apply
              :close-on-auto-apply="false"
              :placeholder="'종료일'"
            ></DatePicker>
          </div>
        </div>
        <div class="col-md-2 mb-2">
          <select class="form-select" v-model="limit">
            <option :value="100">100개</option>
            <option :value="200">200개</option>
          </select>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <div class="input-group mb-2">
              <button type="button" class="btn btn-outline-success" @click="goFirst">처음</button>
              <button type="button" class="btn btn-outline-primary" @click="goPre">이전</button>
              <input type="number" class="form-control" min="1" v-model="page" />
              <button type="button" class="btn btn-outline-info" @click="goNext">다음</button>
            </div>
          </div>
        </div>
        <div class="form-group col-md-1 mb-2">
          <button type="submit" class="btn btn-dark w-100">검색</button>
        </div>
      </div>
    </form>

    <hr class="mt-0 mb-3" />

    <div class="w-100">
      <div class="d-md-flex">

        <!-- 상위 목록 //-->
        <!-- <partner-tree-menu :partner="$store.getters['auth/user']" @setParent="setParent" @searchList="searchList" ref="partnerTreeMenu" v-if="searchByUser != true"></partner-tree-menu> //-->

        <!-- 목록 //-->

        <div id="table-wrapper" class="table-responsive mb-0 rounded-3 w-100" style="overflow: auto;">
          <div class="w-100">
            <div class="card">
              <div class="card-body">
                <!-- 리스트 //-->

                <table class="table align-middle table-sm table-nowrap sticky-table table-striped-columns">
                  <thead class="table-dark">
                  <tr>
                    <th>
                      <a href="javascript:void(0)" @click="setSort('createdAt')">#</a>&nbsp;
                      <template v-if="sort.createdAt"><span class="fa fa-sort-amount-down" v-if="sort.createdAt === -1"></span><span class="fa fa-sort-amount-up" v-if="sort.createdAt === 1"></span></template>
                    </th>
                    <th>상세</th>
                    <th>라운드키</th>
                    <th>상위정보</th>
                    <th>회원정보</th>
                    <th>거래형식</th>
                    <th>게임사</th>
                    <th>게임종류</th>
                    <th>게임형식</th>
                    <th>게임명</th>
                    <th>거래방식</th>
                    <th>이전 보유캐쉬</th>
                    <th>배팅</th>
                    <th>결과</th>
                    <th>이후 보유캐쉬</th>
                    <th>요청일</th>
                    <th>
                      <a href="javascript:void(0)" @click="setSort('createdAt')">처리일</a>&nbsp;
                      <template v-if="sort.createdAt"><span class="fa fa-sort-amount-down" v-if="sort.createdAt === -1"></span><span class="fa fa-sort-amount-up" v-if="sort.createdAt === 1"></span></template>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="(record, i) in filterList" :key="record.id">
                    <tr :class="{'border-bottom border-5': record.children.length === 0, 'bg-danger bg-soft': record.seamlessState === 'error'}">
                      <!-- 번호 //-->
                      <td :rowspan="record.children.length + 1">
                        {{ i + 1}}
                        <!-- 디테일 표시 -->
                        <!--


                        공통 필수조건. seamlessState = finish 이어야함

                        조건1. info(디테일 데이터)가 존재하는경우
                        조건2. 조건없이 없이 출력 (현재 pragmatic, fghub)
                        조건3. 결과 콜백이 있어야만 출력 (현재 cq9, vivo_casino, ag_casino, bota_casino, oriental_casino)
                        -->
<!--                        <span class="badge badge-soft-dark ms-2"  style="cursor: pointer;" @click="openDetail(record)" v-b-tooltip.hover data-placement="top" :title="'상세내역'">상세보기</span>-->


                      </td>
                      <td>
                        <span class="badge badge-soft-dark ms-2"  style="cursor: pointer;" @click="openDetail(record)" v-b-tooltip.hover data-placement="top" :title="'상세내역'">상세보기</span>
                      </td>
                      <td >
                        {{record.siteRoundId}}
                      </td>
                      <!-- 상위정보 //-->
                      <td :rowspan="record.children.length + 1" class="text-start">
                        <router-link :to="'/partner/detail/' + record.top.id" target="_blank" v-if="record.top && record.top.id !== record.user.id && ($store.getters['auth/user'].level != 'super' && $store.getters['auth/user'].level != 'master' && $store.getters['auth/user'].level != 'agent' && $store.getters['auth/user'].level != 'shop')"><partner-badge :partner="record.top" :show-name="true"></partner-badge></router-link>
                        <router-link :to="'/partner/detail/' + record['super'].id" target="_blank" v-if="record['super'] && record['super'].id !== record.user.id && ($store.getters['auth/user'].level != 'master' && $store.getters['auth/user'].level != 'agent' && $store.getters['auth/user'].level != 'shop')"><partner-badge :partner="record.super" :show-name="true"></partner-badge></router-link>
                        <router-link :to="'/partner/detail/' + record.master.id" target="_blank" v-if="record.master && record.master.id !== record.user.id && ($store.getters['auth/user'].level != 'agent' && $store.getters['auth/user'].level != 'shop')"><partner-badge :partner="record.master" :show-name="true"></partner-badge></router-link>
                        <router-link :to="'/partner/detail/' + record.agent.id" target="_blank" v-if="record.agent && record.agent.id !== record.user.id && ($store.getters['auth/user'].level != 'shop')"><partner-badge :partner="record.agent" :show-name="true"></partner-badge></router-link>
                        <router-link :to="'/partner/detail/' + record.shop.id" target="_blank" v-if="record.shop && record.shop.id !== record.user.id"><partner-badge :partner="record.shop" :show-name="true"></partner-badge></router-link>
                      </td>
                      <!-- 회원정보 //-->
                      <td :rowspan="record.children.length + 1" class="text-center">
                        <template v-if="record.user">
                          <span class="ms-1"><router-link :to="'/user/detail/' + record.user.id" target="_blank" v-if="record.user.type === 'user'"><span class="badge badge-soft-info p-1">사이트</span> {{ record.user.siteUsername }}<br />&nbsp;<span class="badge badge-soft-secondary p-1">네오</span> {{ record.user.username }}</router-link></span>
                          <span class="ms-1"><router-link :to="'/partner/detail/' + record.user.id" target="_blank" v-if="record.user.type === 'partner'">{{ record.user.username }}<br />{{ record.user.nickname }}</router-link></span>
                          <!--
                          <br />
                          <span v-if="record.groupKey">{{ record.groupKey }} - </span> {{ record.siteUsername }}
                          //-->
                        </template>
                      </td>
                      <!-- 거래 형식 //-->
                      <td :rowspan="record.children.length + 1">
                        <badge-seamless :use-seamless="record.parent.useSeamless" v-if="record.parent && record.category === 'turn'"></badge-seamless>
                        <badge-transaction-category :record="record"></badge-transaction-category>
                      </td>
                      <!-- 게임사 //-->
                      <td :rowspan="record.children.length + 1">
                        <span class="badge bg-danger" v-if="record.isEvent == 1" :hidden="$store.getters['auth/user'].type !== 'admin'">F</span> {{ record.vendorName }}
                      </td>
                      <!-- 게임종류 //-->
                      <td :rowspan="record.children.length + 1">
                        <badge-game-category :record="record"></badge-game-category>
                      </td>
                      <!-- 게임형식 //-->
                      <td :rowspan="record.children.length + 1">{{ record.gameTypeName.toUpperCase() }}</td>
                      <!-- 게임명 //-->
                      <td :class="{'text-start': record.gameCategoryKey === 'slot'}" :rowspan="record.children.length + 1">
                        {{ record.categoryKey }}
                        <img :src="record.gameImage" style="width: 32px;" class="img-thumbnail" v-if="record.gameImage" />
                        {{ record.gameName }}
                      </td>
                      <!-- 거래 방식 //-->
                      <td>
                        <!--
                        method: game, category: money, type: send or receive => 사이트<->케이곤 머니이동
                        method: cash, category: cash(파트너) or money(회원), type: send or receive => 회원간 캐쉬 이동(입/출금)
                        method: game, category: turn, type: bet or win or draw or cancel => 게임 플레이
                        //-->
                        <span class="badge ms-1 badge-soft-danger" style="cursor: pointer;" v-if="record.parent.useSeamless === 1 && record.seamlessState === 'error'" v-b-tooltip.hover data-placement="top" :title="record.seamlessErrorMsg" @click="openSeamlessLog(record)"><i class="fa fa-check"></i></span>
                        <span class="badge badge-soft-dark" style="cursor: pointer;" @click="openData(record)" v-b-tooltip.hover data-placement="top" :title="'게임데이터'"><i class="fa fa-book"></i></span>
                        <badge-transaction-type :record="record"></badge-transaction-type>
                      </td>
                      <!-- 이전 보유알 //-->
                      <td class="text-end">{{ record.beforeAmount.floatVal(2).formatThousands() }}</td>
                      <!-- 금액 //-->
                      <td class="text-end">
                        <!-- 에볼류션 //-->
                        <template v-if="record.info && record.info.code === 0 && record.vendorKey === 'evolution_casino'">
                          <p v-for="(bet, index) in record.info.bets" :key="record.transactionKey + '_' + index">
                            <badge-game-target :target="bet.target.toLowerCase()"></badge-game-target>&nbsp;
                            <span>{{ bet.bet.formatThousands() }}</span>
                          </p>
                        </template>
                        <template v-else>
                          {{ record.amount.formatThousands() }}
                        </template>
                      </td>
                      <!-- 수익금 //-->
                      <td class="text-end">
                        <template v-if="record.info && record.info.code === 0 && record.vendorKey === 'evolution_casino'">
                          <p v-for="(bet, index) in record.info.bets" :key="record.transactionKey + '_result_' + index">
                            <badge-game-target :target="record.info.result.toLowerCase()" v-if="record.info && record.info.result"></badge-game-target>&nbsp;
                            <span :class="{'text-danger': bet.win <= 0, 'text-primary': bet.win > 0}">{{ bet.win.formatThousands() }}</span>
                          </p>
                        </template>
                      </td>
                      <!-- 이후 보유알 //-->
                      <td class="text-end">{{ record.afterAmount.floatVal(2).formatThousands() }}</td>
                      <!-- 요청일(requestedAt) //-->
                      <td class="small">{{ new Date(record.requestedAt).format('YYYY-MM-DD HH:mm:ss.zzz') }}</td>
                      <!-- 처리일(createdAt) //-->
                      <td class="small">{{ new Date(record.createdAt).format('YYYY-MM-DD HH:mm:ss.zzz') }}</td>
                    </tr>

                    <tr v-for="(child, index) in record.children" :key="'result-' + record.transactionKey + '-' + index" class="border-bottom border-5">
                      <td>
                        <span class="badge ms-1" style="cursor: pointer;" v-if="child.parent.useSeamless === 1 && child.seamlessState === 'error'" :class="{'badge-soft-danger': child.seamlessState === 'error', 'badge-soft-primary': child.seamlessState === 'finish', 'badge-soft-secondary': child.seamlessState === 'ready'}" v-b-tooltip.hover data-placement="top" :title="child.seamlessErrorMsg" @click="openSeamlessLog(child)"><i class="fa fa-check"></i></span>
                        <span class="badge badge-soft-dark" style="cursor: pointer;" @click="openData(child)" v-b-tooltip.hover data-placement="top" :title="'결과데이터'"><i class="fa fa-book"></i></span>
                        <badge-transaction-type :record="child"></badge-transaction-type>
                      </td>
                      <td class="text-end">{{ child.beforeAmount.floatVal(2).formatThousands() }}</td>
                      <td>
                        <span v-if="record.vendorKey === 'evolution_casino'">{{ record.amount.formatThousands() }}</span>
                      </td>
                      <td class="text-end">
                            <span :class="{'text-danger': child.amount <= 0, 'text-primary': child.amount > 0}">
                              {{ child.amount.formatThousands() }}
                            </span>
                      </td>
                      <td class="text-end">{{ child.afterAmount.floatVal(2).formatThousands() }}</td>
                      <td class="small">{{ new Date(child.requestedAt).format('YYYY-MM-DD HH:mm:ss.zzz') }}</td>
                      <td class="small">{{ new Date(child.createdAt).format('YYYY-MM-DD HH:mm:ss.zzz') }}</td>
                    </tr>
                  </template>
                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Detail ref="modal-detail" />
  </div>
</template>
